import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { toggleModalAction } from '../redux/actions/userAction'
import { isTablet } from 'react-device-detect';

const ModalContainer = ({ modalState }) => {
  return <div>
    {modalState.toggleStatus && window.sessionStorage["channel"] == "PKAPS" ?

      (<div className="fixed absolute--fill relative z-999 ph3 pv4 flex justify-center o-93 items-center" style={{ backgroundColor: "rgba(0,0,0,0.8)" }}>
        <div onClick={(e) => e.stopPropagation()} className="">
          {modalState.component}
        </div>
      </div>)
      :

      (modalState.toggleStatus && <div className="fixed absolute--fill relative z-999 ph3 pv4 flex justify-center o-93 items-center" style={{ backgroundColor: "rgba(0,0,0,0.8)" }}>
        <div onClick={(e) => e.stopPropagation()} className="z-15 " style={{...(isTablet ? {width:"50%"} : {width:"90%"})}}>
          {modalState.component}
        </div>
      </div>)

    }
  </div>
}

ModalContainer.propTypes = {
  modalState: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  modalState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction }
)(ModalContainer);
